import BarButtonFw, { BUTTON_DEFAULT } from '../../../framework/bar-button/BarButtonFw';
import FormFw from '../../../framework/form/FormFw';
import GridFw, { COLUMN_DEFAULT } from '../../../framework/grid/GridFw'
import { BasePage } from "../../../framework/pages/BasePage";
import { DATE_FORMAT, MIME_TYPE } from '../../../constants/constants';
import { DocumentPreview } from '../../viewDocument/DocumentPreview';
import { LoadingUtil } from '../../../util/LoadingUtil';
import { EnvConstants } from '../../../EnvConstants';
import { DonwloadUtil } from '../../../util/DonwloadUtil';
import { UserUtil } from '../../../util/UserUtil';
import { PAGE_MODE } from "../../../constants/constants";
import GenerarCadenaModal from '../modals/GenerarCadenaModal';
import { SELECTION_TYPE } from '../../../framework/grid/GridFw';
import { LoadUtil } from '../../../framework/util/LoadUtil';
import { RequestUtil } from '../../../util/RequestUtil';
import { withRouter } from 'react-router-dom';
import { MessageUtil } from '../../../util/MessageUtil';
import confirm from 'antd/lib/modal/confirm';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { ICON } from '../../../constants/iconConstants';
import { S3Util } from '../../../util/S3Util';
import './SolicitudAsignadaDetailPage.css'
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';


class SolicitudAsignadaDetailPage extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      numeracionSolicitud: ''
    };
  };

  renderPage(pageApi) {
    const getlistcadenaGrid = () => pageApi.getComponent('grid');
    const getlistcadenaForm = () => pageApi.getComponent('form');

const DocumentPreviewModal = (data) => {
      // return {
      //   width: 950,
      //   maskClosable: true,
      //   closable: false,
      //   component: <DocumentPreview name={data} getParentApi={pageApi.getApi} />
      // }
           return {
                // title: data.name_file,
                width: 950,
                maskClosable: true,
                closable: false,
                component: <>
                    <Button
                        type="success"
                        size='small'
                        style={{ marginLeft: 'auto', display: 'block' }}
                        icon={<DownloadOutlined />}
                        onClick={async () => {
                            const link = document.createElement("a");
                            link.href = data.url;
                            link.download = data.name_download;
                            link.click();
                        }}
                    >Descargar</Button>
                    <DocumentPreview name={data} getParentApi={pageApi.getApi} />
                </>
            }
    };


    const formlistcadenaConfig = {
      layout: 'vertical',
      title: 'Filtro de Búsqueda',
      load: {
        validation: () => pageApi.getParamId() != null,
        queryId: 870,
        params: { id_doc: pageApi.getParamId() },
        hideMessage: true,
        hideMessageError: true,
        fnOk: async () => {
          const reqParams = LoadUtil.getReqParams({
            queryId: 870,
            params: { id_doc: pageApi.getParamId() },
          });

          const resp = await RequestUtil
            .postData(EnvConstants.GET_URL_READ(), reqParams)
            .then(r => r.dataObject)
            .catch(() => null);

          let values = getlistcadenaForm().getData();
          values = { ...values, detalle: resp.detalle }
          getlistcadenaForm().setData(values)
        }
      },
      fields: [
        { name: 'detalle', label: '', column: 12, readOnly: true },
        { name: 'nroIA', label: 'Nro.IA:', column: 3 },
        { name: 'cadena', label: 'Nro.Cadena:', column: 3 },
        {
          type: "select", name: "matriz", label: "Matriz", column: 6, load: {
            queryId: 941, params: { id_ss: pageApi.getParamId() }
          }, search: true,
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW)
          formApi.load();
      }
    }

    const redirecCadena = (row) => {
      if (row.es_generado_inspector) {
        return `/solicitudes-asignadas/solicitudes-asignadas/cadenas/${row.ID_CADENA}`;
      } else {
        if (row.NOMBRE_CADENA === 'Ocupacional - Ruido') return `/atc/servicios-oma/ocupacional-ruido/${row.ID_CADENA}/update`
        else if (row.NOMBRE_CADENA === 'Ocupacional - Iluminación') return `/atc/servicios-oma/ocupacional-iluminacion/${row.ID_CADENA}/update`
        else if (row.NOMBRE_CADENA === 'Ocupacional - Gases') return `/atc/servicios-oma/ocupacional-gases/${row.ID_CADENA}/update`
        else if (row.NOMBRE_CADENA === 'Ocupacional - Agentes Químicos') return `/atc/servicios-oma/ocupacional-gases/${row.ID_CADENA}/update`
        else if (row.NOMBRE_CADENA === 'Ocupacional - Estrés Térmico') return `/atc/servicios-oma/ocupacional-estres-termico/${row.ID_CADENA}/update`
        else if (row.NOMBRE_CADENA === 'Matriz Agua') return `/atc/servicios-oma/matriz-agua/${row.ID_CADENA}/update`
        else if (row.NOMBRE_CADENA === 'Matriz Aire') return `/atc/servicios-oma/matriz-aire/${row.ID_CADENA}/update`
        else if (row.NOMBRE_CADENA === 'Matriz Suelo') return `/atc/servicios-oma/matriz-suelo/${row.ID_CADENA}/update`
        else if (row.NOMBRE_CADENA === 'Matriz Ruido') return `/atc/servicios-oma/matriz-ruido/${row.ID_CADENA}/update`
        else if (row.NOMBRE_CADENA === 'Matriz Emisiones') return `/atc/servicios-oma/matriz-emision/${row.ID_CADENA}/update`
        else if (row.NOMBRE_CADENA === 'Matriz Emisiones Gaseosas EPA 10') return `/atc/servicios-oma/matriz-aire-foma-122/${row.ID_CADENA}/update`
        else if (row.NOMBRE_CADENA === 'Matriz Radiaciones') return `/atc/servicios-oma/matriz-radiacion/${row.ID_CADENA}/update`
        else if (row.NOMBRE_CADENA === 'Matriz FOMA 066 No Acreditado') return `/atc/servicios-oma/matriz-radiacion-no-acreditado/${row.ID_CADENA}/update`
        else if (row.NOMBRE_CADENA === 'Matriz Iluminaciones') return `/atc/servicios-oma/matriz-iluminacion/${row.ID_CADENA}/update`
        else if (row.NOMBRE_CADENA === 'Matriz Vibraciones') return `/atc/servicios-oma/matriz-vibracion/${row.ID_CADENA}/update`
      }
    }

    const gridlistcadenaConfig = {
      showIndex: true,
      autoLoad: true,
      pagination: { server: true, showSizeChanger: true },
      selection: { type: SELECTION_TYPE.MULTIPLE },
      load: {
        queryId: 876,
        params: {
          id_user: UserUtil.getUserId(),
          ID_SOLICITUD_SERVICIO: pageApi.getParamId()
        },
        hideMessage: true,
        hideMessageError: true,
      },
      fields: [
        { name: 'NRO_CC', label: 'Codigo Cadena' },
        { name: 'nro_ia', label: 'Nro IA' },
        { 
          name: 'TIPO_CADENA', 
          label: 'Tipo Cadena', 
          labelName: 'NOMBRE_CADENA', 
          editable: true, 
          type: 'select', 
          load: { 
            queryId: 976, 
            params: () => {
              return {
                arr_id_matriz: getlistcadenaGrid()?.getItemEditing()?.arr_id_matriz
              } 
            }
          }, 
          search: true,
          onChange: (value, row, formApi) => {
            const data = formApi.getFieldApi('TIPO_CADENA')?.dataList || [];
            const editing = getlistcadenaGrid().getItemEditing();
            const find = data.find(el => el.value === value); 
            
            if (value !== editing.TIPO_CADENA) {
              const reqParams = LoadUtil.getReqParams({
                queryId: 977,
                params: {
                  id_user: UserUtil.getUserId(),
                  id_cadena: editing.ID_CADENA,
                  id_tipo_cadena: find?.value,
                },
              });

              RequestUtil.postData(
                EnvConstants.GET_FW_FORM_URL_SAVE_BASE(),
                reqParams,
              ).then((resp) => {
                if (resp.error) MessageUtil('warning', resp.error);
                if (resp.message) MessageUtil('success', resp.message);

                getlistcadenaGrid().saveItemEditing();
                getlistcadenaGrid().load();
              }).catch((err) => {
                console.error(err)
                getlistcadenaGrid().saveItemEditing();
              });
            }
          }
        },
        { 
          name: 'id_subtipo_cadena', 
          label: 'Sub. Tipo Cadena', 
          labelName: 'subtipo_cadena', 
          editable: true, 
          type: 'select', 
          parents: [{ name: "TIPO_CADENA", paramName: "tipo_cadena", required: true }],
          load: { 
            queryId: 974,
            params: {
              id_ss: pageApi.getParamId(),
            }
          }, 
          search: true,
          onChange: (value, row, formApi) => {
            const data = formApi.getFieldApi('id_subtipo_cadena')?.dataList || [];
            const editing = getlistcadenaGrid().getItemEditing();
            const find = data.find(el => el.value === value); 
            
            if (value !== editing.id_subtipo_cadena) {
              const reqParams = LoadUtil.getReqParams({
                queryId: 975,
                params: {
                  id_user: UserUtil.getUserId(),
                  id_cadena: editing.ID_CADENA,
                  id_acreditador: find?.id_acreditador,
                  id_sub_contr: find?.id_sub_contr
                },
              });

              RequestUtil.postData(
                EnvConstants.GET_FW_FORM_URL_SAVE_BASE(),
                reqParams,
              ).then((resp) => {
                if (resp.error) MessageUtil('warning', resp.error);
                if (resp.message) MessageUtil('success', resp.message);

                getlistcadenaGrid().saveItemEditing();
                getlistcadenaGrid().load();
              }).catch((err) => {
                console.error(err)
                getlistcadenaGrid().saveItemEditing();
              });
            }
          }
        },
        { name: 'MATRIZ', label: 'Matriz' },
        { name: 'estaciones', label: 'Estaciones' },
        {
          type: "date",
          name: "FECHA_CREACION",
          label: "F.Registro",
          format: DATE_FORMAT.DDMMYYYY,
        },
        { name: 'estado', label: 'Estado' },
        { name: 'fecha_firmado_supervisor', label: 'Fecha Aprobación Ins.' },
        { name: 'fecha_firmado_cliente', label: 'Fecha Aprobación Cli.' },
        { name: 'inspector_aprobador', label: 'Inspector Aprobador' },
        {
          ...COLUMN_DEFAULT.EDIT, label: 'Opciones', colSpan: 6, title: 'Detalle Cadena', color: 'blue', onClick: (_, row) => {
            if (row.config_subtipo_cadena) {
              this.props.history.push({
                pathname: redirecCadena(row),
                state: { from: this.props.history.location.pathname }
              });
            } else {
              MessageUtil('warning', 'La cadena aún no se ha configurado en Sub Tipo Cadena.');
            }
          },
        },
        {
          ...COLUMN_DEFAULT.PDF, title: 'Visualizar Cadena', color: 'black', colSpan: 0, fnVisible: (_, row) => row.es_generado_inspector, onClick: (value, row, index) => {
            LoadingUtil.loadShow();
            let url = EnvConstants.GET_REPORT2_URL() + 'List_Cadena_MA';
            DonwloadUtil.donwloadBlob(url, { params: { ID_CADENA: row.ID_CADENA } }, "Cadena_" + row.nro_ia + ".pdf").then(x => {
              var reader = new FileReader();
              reader.readAsDataURL(x.blob);
              reader.onloadend = function () { 
                var base64data = reader.result;
                let obj = {
                  url: base64data,
                  type_file: MIME_TYPE.pdf,
                  // name_file: "nombre",
                  name_download: row.nombre_archivo_descarga
                }
                pageApi.showModal(DocumentPreviewModal(obj));
                LoadingUtil.loadHide();
              }
            }).catch(x => {
              console.error(x)
              LoadingUtil.loadHide();
            });
          },
            fnVisible: (value, row, index) => {
            return row?.es_generado_inspector == 1;
          },
        },
        {...COLUMN_DEFAULT.DOWNLOAD,
          onClick: (value, row, index) => {
            S3Util.donwload(
            row.FILENAME,
            "bvdigital-repository-ma-per-pr/atc/servicios-oma/planificacion-solicitud"
            );
          },
          fnVisible: (value, row, index) => { 
            return row?.es_generado_inspector == 2;
          }
        },
        {
          ...COLUMN_DEFAULT.DOCUMENT,
          colSpan: 4,
          onClick: (value, row) => {
            LoadUtil.loadByQueryId({
              url: EnvConstants.GET_FW_FORM_URL_LOAD_BASE(),
              queryId: 485,
              reqParams: {
                params: {
                  ID_CADENA: row.ID_CADENA,
                },
              },
              fnOk: (resp) => {
                if (resp.dataList === null) {
                  return MessageUtil(
                    "warning",
                    "Alerta!",
                    "No se ha encontrado ningun documento!",
                  );
                } else {
                  let data = resp.dataList[0];
                  async function getUrl(file_name, ruta) {
                    let result = await S3Util.getUrlS3(file_name, ruta);
                    return result;
                  }

                  getUrl(
                    data.FILENAME,
                    "bvdigital-repository-ma-per-pr/solicitud-servicio/cadena-custodia",
                  ).then((urlComplete) => {
                    window.open(urlComplete, urlComplete);
                  });
                }
              },
            });
          },
          fnVisible: (value, row, index) => {
            return row?.es_adjunto === "SI";
          },
        },
        {
          name: "delete", type: "button", icon: ICON.DELETE, title: 'Eliminar cadena', color: 'red',
          fnVisible: (_, row) => {
            return row.ID_IA === null ? true : false
          },
          onClick: (value, row) => {
            confirm({
              title: '¿Está seguro de eliminar esta cadena?',
              icon: <ExclamationCircleOutlined />,
              content: `Cadena: ${row.NRO_CC}`,
              onOk() {
                LoadUtil.loadByQueryId({
                  url: EnvConstants.GET_FW_FORM_URL_SAVE_BASE(),
                  queryId: 914,
                  params: { id_cadena: row.ID_CADENA },
                  fnOk: (resp) => {
                    if (!resp.error) {
                      getlistcadenaGrid().load({
                        params: {
                          ...getlistcadenaForm().getData(),
                          nroIA: getlistcadenaForm()?.getData()?.nroIA || null,
                          cadena: getlistcadenaForm()?.getData()?.cadena || null,
                          matriz: getlistcadenaForm()?.getData()?.matriz || null,
                        }
                      });
                      MessageUtil("success", resp.message, "");
                    } else {
                      MessageUtil("warning", resp.error, "");
                    }
                  }
                })
              },
              onCancel() {

              },
            });
          }
        }
      ]
    };

    const ListaCadenaConfig = {
      events: {

      }
    }

    const GenerarCadenaModalConfig = (data) => {
      return {
        width: 650,
        maskClosable: false,
        closable: true,
        background: 'white',
        component: <GenerarCadenaModal name={data} getParentApi={pageApi.getApi} config={ListaCadenaConfig} />
      }
    };

    const barButtonlistcadenaconfig = {
      fields: [
        {
          ...BUTTON_DEFAULT.SEARCH, onClick: () => getlistcadenaGrid().load({
            params: {
              ...getlistcadenaForm().getData(),
              nroIA: getlistcadenaForm()?.getData()?.nroIA || null,
              cadena: getlistcadenaForm()?.getData()?.cadena || null,
              matriz: getlistcadenaForm()?.getData()?.matriz || null,
            }
          })
        },
        { ...BUTTON_DEFAULT.RETURN, label: "Regresar", link: "/solicitudes-asignadas/solicitudes-asignadas-admin", },
        {
          ...BUTTON_DEFAULT.NEW, label: 'Crear Nueva Cadena', onClick: () => {
            pageApi.showModal(GenerarCadenaModalConfig({
              id_ss: pageApi.getParamId()
            }));
          }
        },
        {
          ...BUTTON_DEFAULT.EXECUTE, label: "Aprobar", onClick: () => {
            // const arrCadena = Array.from(getlistcadenaGrid()?.getSelectedItem(), el => el.ID_CADENA);
         
            const arrCadena = Array.from(getlistcadenaGrid()?.getSelectedItem(), el => ({
              ID_CADENA: el.ID_CADENA,
              correo_nocumple: el.correo_nocumple,
              PLAN_PROCEDIMIENTO: el.PLAN_PROCEDIMIENTO,
              NRO_CC: el.NRO_CC
            }));

            console.log(arrCadena)
               if (arrCadena){
                 arrCadena.forEach(item => {  
                  if(item.PLAN_PROCEDIMIENTO != "0"){ 
                    LoadUtil.loadByQueryId({ 
                      url: EnvConstants.GET_FW_FORM_URL_SAVE_BASE(),
                      queryId: 887,
                      reqParams: {
                        params: {
                          cadenas: item.ID_CADENA,
                          firma_supervisor: true,
                          id_usuario: UserUtil.getUserId(),
                        },
                      }, 
                      fnOk: (resp) => { 
                        console.log(resp)  
                        if (!resp.error) { 
                          if(resp.message === "Se han firmado la(s) cadena(s) correctamente."){ 
                            MessageUtil("success", resp.message, "");  
                          }
                        else {     
                          LoadUtil.loadByQueryId({
                            url: EnvConstants.GET_FW_URL_SEND_MAIL() + '/Cadena_Correo',
                            queryId: 971,
                            reqParams: {
                            params: { ID_CADENA: item.ID_CADENA,id_usuario: UserUtil.getUserId() }
                            },
                            fnOk: (resp) => {
                              console.log(resp)  
                              LoadUtil.loadByQueryId({
                                url: EnvConstants.GET_FW_FORM_URL_SAVE_BASE(),
                                queryId: 983,
                                reqParams: {
                                  params: {
                                    ID_CADENA: item.ID_CADENA,det_respuesta: resp.message,id_usuario: UserUtil.getUserId(),
                                    desc_error: resp.error 
                                  },
                                }, 
                              }); 
                              MessageUtil(
                                  'success', 
                                  resp.message + '.'
                              );  
                            }
                            })
                            if(item.correo_nocumple > 0){
                                LoadUtil.loadByQueryId({
                                url: EnvConstants.GET_FW_URL_SEND_MAIL() + '/Cadena_Correo_NoCumple',
                                queryId: 982,
                                reqParams: {
                                params: { ID_CADENA: item.ID_CADENA,id_usuario: UserUtil.getUserId(),correo_nocumple: item.correo_nocumple, }
                                },
                                fnOk: (resp) => {
                                  console.log(resp) 
                                  LoadUtil.loadByQueryId({
                                  url: EnvConstants.GET_FW_FORM_URL_SAVE_BASE(),
                                  queryId: 983,
                                  reqParams: {
                                    params: {
                                      ID_CADENA: item.ID_CADENA,det_respuesta: resp.message,id_usuario: UserUtil.getUserId(),
                                      desc_error: resp.error 
                                    },
                                  }, 
                                });
                                  MessageUtil(
                                      'success', 
                                      resp.message + '.'
                                  );  }
                                });
                            } 
                          } 
                        } else {
                          MessageUtil("warning", resp.error, "");
                        } 
                        getlistcadenaGrid().load();
                      },
                    }); 
                  }
                  else {
                     MessageUtil("warning", "la cadena "+ item.NRO_CC + " no cuenta con Plan de Procedimiento" , "");  
                  }
                })
               } 
        
        
            }
        }, 
        { ...BUTTON_DEFAULT.DELETE, label: 'Eliminar', onClick: () => {
          confirm({
              title: 'Desea eliminar las cadenas',
              icon: <ExclamationCircleOutlined />,
              onOk() { 
                const arrCadena = Array.from(getlistcadenaGrid()?.getSelectedItem(), el => el.ID_CADENA);

                  if (arrCadena){ 
                        arrCadena.forEach(item => {  
                            LoadUtil.loadByQueryId({
                              url: EnvConstants.GET_FW_FORM_URL_UPDATE_BASE(),
                              queryId: 914,
                              reqParams: {
                                  params: {id_cadena: item, id_user: UserUtil.getUserId()},
                              },
                              fnOk: (resp) => {
                                  if (resp?.dataObject == 1) {
                                     MessageUtil("warning", resp.message, "");
                                  }
                                  else if (!resp.error) {
                                    getlistcadenaGrid().load({
                                      params: {
                                      ...getlistcadenaForm().getData(),
                                      nroIA: getlistcadenaForm()?.getData()?.nroIA || null,
                                      cadena: getlistcadenaForm()?.getData()?.cadena || null,
                                      matriz: getlistcadenaForm()?.getData()?.matriz || null,
                                      }
                                    });
                                    MessageUtil("success", resp.message, "");
                                  } else {
                                  MessageUtil("warning", resp.error, "");
                                  }   
                              },
                          }); 
                        });
                   };

              },
              onCancel() { },
          });
        }},
      ]
    }

    return (
      <>
        <div className='base-page-header '>{getlistcadenaForm()?.getData()?.detalle}</div>
        <FormFw
          name="form"
          getParentApi={pageApi.getApi}
          config={formlistcadenaConfig}
        />
        <BarButtonFw
          name="bar"
          getParentApi={pageApi.getApi}
          config={barButtonlistcadenaconfig}
        />
        <div class='solicitudAsignadaDetailTable'>
          <GridFw
            name="grid"
            getParentApi={pageApi.getApi}
            config={gridlistcadenaConfig}
          />
        </div>
      </>
    )
  }
}

export default withRouter(SolicitudAsignadaDetailPage);